<template>
  <span>
    <div
      v-if="showTotalPercentage"
      class="sf-align-c sf-progress-total-percent"
    >
      <slot name="percentage-label" />
    </div>
    <div
      v-for="section in modifiedSections"
      :key="section.key"
      :class="section.class"
      :style="section.style"
    />
  </span>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true,
    },
    showTotalPercentage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    modifiedSections() {
      return this.sections.map((section) => ({
        key: section.i18nKey,
        class: {
          'sf-progress-complete': true,
          [`sf-bg-${section.color}`]: true,
        },
        style: {
          width: this.widthForSection(section) + '%',
        },
      }))
    },
    total() {
      return this.sections.reduce((sum, section) => {
        return section.total + sum
      }, 0)
    },
  },

  methods: {
    widthForSection(section) {
      return (section.done / this.total) * 100
    },
  },
}
</script>

<style scoped>
.sf-progress-total-percent {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  line-height: 1.3;
}
</style>
